import type { ColumnSort } from '@plato/ui/components/data-table';
import { useMemo } from 'react';
import type { ExplorerSort } from '../../../server/utils/explorer-utils.ts';
import { ExplorerSortOrder, isExplorerSortBy } from '../../../server/utils/explorer-utils.ts';
import { useAnalytics } from '../../analytics/hooks/use-analytics.ts';

export function useExplorerSorting(
    sortingFilter: ExplorerSort | null,
    setSortingFilter: (sortingFilter: ExplorerSort | null) => void,
) {
    const sendEvent = useAnalytics();

    const sorting = useMemo((): ColumnSort | undefined => {
        if (sortingFilter) {
            return { id: sortingFilter.field, direction: sortingFilter.direction };
        } else {
            return undefined;
        }
    }, [sortingFilter]);

    const sortChangedInInterface = (sort: ColumnSort | undefined): void => {
        if (!sort) {
            setSortingFilter(null);
        } else if (isExplorerSortBy(sort.id)) {
            setSortingFilter({ field: sort.id, direction: sort.direction });
            sendEvent('sales_report_sort_used', {
                column: sort.id,
                direction: sort.direction === ExplorerSortOrder.DESC ? 'DESC' : 'ASC',
            });
        }
    };

    return { sorting, sortChangedInInterface };
}
